"use strict";
/** @license MIT License (c) copyright 2010-2014 original author or authors */
/** @author Brian Cavalier */
/** @author John Hann */
Object.defineProperty(exports, "__esModule", { value: true });
var OpType;
(function (OpType) {
    OpType["Test"] = "test";
    OpType["Add"] = "add";
    OpType["Remove"] = "remove";
    OpType["Replace"] = "replace";
    OpType["Move"] = "move";
    OpType["Copy"] = "copy";
})(OpType = exports.OpType || (exports.OpType = {}));
function defaultHash(x) {
    return isValidObject(x) || isArray(x) ? JSON.stringify(x) : x;
}
exports.defaultHash = defaultHash;
function isValidObject(x) {
    return x != null && Object.prototype.toString.call(x) === "[object Object]";
}
exports.isValidObject = isValidObject;
var clone_1 = require("./clone");
exports.clone = clone_1.clone;
function isArray(x) {
    return Object.prototype.toString.call(x) === "[object Array]";
}
